import { z } from 'zod';

import { color, colorNoBlackOrWhite, colorRequired } from './utils/color';

export const globalStyleTemplateColorsUpdate = z.object({
  primaryColor: colorNoBlackOrWhite,
  secondaryColor: colorNoBlackOrWhite,
  backgroundColor: colorNoBlackOrWhite,
  accentColor: colorNoBlackOrWhite,
});

export const globalStyleSchema = z.object({
  buttonColor: colorRequired.nullable(),
  buttonFontColor: colorRequired.nullable(),
  headlineFont: z.string().trim(),
  headlineFontColor: colorRequired.nullable(),
  headlineFontSize: z.number().nullable(),
  headlineFontSizeUnit: z.string().nullable(),
  pageWidth: z.number().nullable(),
  pageWidthUnit: z.string().nullable(),
  paragraphFont: z.string().trim(),
  paragraphFontColor: colorRequired.nullable(),
  paragraphFontSize: z.number().nullable(),
  paragraphFontSizeUnit: z.string().nullable(),
  primaryColor: colorRequired.nullable(),
  secondaryColor: colorRequired.nullable(),
  templateColors: globalStyleTemplateColorsUpdate,
  additionalColors: z.array(z.object({ color })),
});

export const globalStyleWithHueSchema = globalStyleSchema.extend({
  hueRotate: z.number().nullable(),
});

export type GlobalStyleSchemaWithHue = z.infer<typeof globalStyleWithHueSchema>;
type GlobalStyleSchemaWithoutHue = z.infer<typeof globalStyleSchema>;
export type GlobalStyleSchema =
  | GlobalStyleSchemaWithHue
  | GlobalStyleSchemaWithoutHue;

export type ITemplateColorsUpdateSchema = z.infer<
  typeof globalStyleTemplateColorsUpdate
>;

export const templateColorsSchema = z.object({
  templateColors: z.object({
    primaryColor: colorNoBlackOrWhite,
    secondaryColor: colorNoBlackOrWhite,
    backgroundColor: colorNoBlackOrWhite,
    accentColor: colorNoBlackOrWhite,
  }),
  additionalColors: z.array(
    z.object({
      color: z.string(),
    })
  ),
});

export type TemplateColorsSchema = z.infer<typeof templateColorsSchema>;
